export default __webpack_public_path__ + "static/media/pin-destination.7beee5c6.svg";